export enum DialogSize {
  Small = 'p-dialog-small',
  Medium = 'p-dialog-medium',
  Large = 'p-dialog-large',
  XLarge = 'p-dialog-xlarge'
}

export enum DialogStyle {
  NoPad = 'p-dialog-padding-none'
}
